import { Checkbox, useTheme } from '@mui/material'
import React from 'react'

interface Props {
  defaultChecked: boolean
  onCheck: (anchorEl: HTMLButtonElement | null) => void
  onUncheck: (anchorEl: HTMLButtonElement | null) => void
}

const MaintenanceAssignCheckBox: React.FC<Props> = ({ onCheck, defaultChecked, onUncheck }) => {
  const theme = useTheme()

  return (
    <>
      <Checkbox
        onChange={event => {
          if (!event.target.checked) {
            onUncheck(event.currentTarget as HTMLButtonElement)
          } else {
            onCheck(event.currentTarget as HTMLButtonElement)
          }
        }}
        checked={defaultChecked}
        sx={{
          color: theme.palette.primaryMain[theme.palette.mode],
          '& .MuiSvgIcon-root': {
            fill: theme.palette.primaryMain[theme.palette.mode],
          },
        }}
      />
    </>
  )
}

export default MaintenanceAssignCheckBox
